//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["nav_bar"],
  data() {
    return {};
  },
  methods: {
    cur_nav(idx) {
      this.$emit("call_back", idx);
    }
  }
};
